module.exports = __webpack_public_path__ + "static/media/Img_16.84b2e7c8.JPG";